// @mmfestival/shared-components/data/TrilogyDetail.jsx
export const TrilogyDetail = [
  {
    id: "JMM",
    eventId: "JMM",
    slug: "JMM",
    title: "JAVA MOUNTAIN MARATHON",
    logo: "/logo/smm.png",
    logodetail: "/logo/smm1.png",
    type: "trail_running",
    status: "Registrasi Ditutup",
    location: "TN Gunung Gede Pangrango",
    image: "/bg/bghero2.png",
    currentImage: "/bg/bghero2.png",
    price: 0,
    websiteUrl: "https://jmm2025.cakrawalajakarta.id",
    aboutEvent:
      "Java Mountain Marathon adalah event trail running yang menantang di kawasan Gunung Gede Pangrango, Jawa Barat. Event ini dirancang untuk pelari yang ingin merasakan pengalaman berlari di medan pegunungan dengan pemandangan alam yang spektakuler.",
    createdAt: "30 Jul 2025 at 18:09:08 UTC+7",
    updatedAt: "4 Nov 2025 at 21:44:46 UTC+7",
    detailPath: "/JMM", // LINK STATIS
    categories: [
      {
        categoryName: "Vertical (7K)",
        cot: 2,
        date: "2025-11-15",
        description:
          "Vertical Challenge (7 Km) | Elevation Gain 1.117 mdpl Kategori khusus dengan rute menanjak dari Balai Besar TNGGP Cibodas menuju Camp Area Kandang Badak.",
        distance: 7,
        elevationGain: 1117,
        eventDateTimestamp: "15 Nov 2025 at 06:30:00 UTC+7",
        gpxFileUrl: "",
        imageUrl: "",
        mapUrl: "",
        price: 700000,
        rundown: [{ time: "06:30" }],
      },
      {
        categoryName: "Classic Distance (20K)",
        cot: 12,
        date: "2025-11-15",
        description:
          "Classic Distance - 20 KM | Elevation Gain ±1.586 m Rute dimulai dari Balai TNGGP Cibodas menuju Kandang Badak.",
        distance: 20,
        elevationGain: 1673,
        eventDateTimestamp: "15 Nov 2025 at 03:00:00 UTC+7",
        gpxFileUrl: "",
        imageUrl: "",
        mapUrl: "",
        price: 759900,
        rundown: [{ time: "03:00" }],
      },
    ],
  },

  {
    id: "SMM",
    eventId: "SMM",
    slug: "SMM",
    title: "SEMBALUN MOUNTAIN MARATHON",
    logo: "/logo/smm.png",
    logodetail: "/logo/smm1.png",
    type: "trail_running",
    status: "Registrasi Dibuka",
    location: "Sembalun, Lombok Timur",
    image: "/bg/bghero2.png",
    currentImage: "/bg/bghero2.png",
    price: 0,
    websiteUrl: "https://smm2025.cakrawalajakarta.id",
    aboutEvent:
      "SMM (Sembalun Mountain Marathon) adalah event trail running resmi yang menantang di kawasan Sembalun, Lombok Timur. Event ini menawarkan pengalaman unik berlari di kaki Gunung Rinjani dengan pemandangan savana yang memukau.",
    createdAt: "30 Jul 2025 at 18:09:08 UTC+7",
    updatedAt: "4 Nov 2025 at 21:44:46 UTC+7",
    detailPath: "/SMM", // LINK STATIS
    categories: [
      {
        categoryName: "Vertical (7K)",
        cot: 2,
        date: "2025-09-27",
        description:
          "Vertical Challenge (7 Km) (KEJURDA ALTI DKI ONLY) | Elevation Gain 1.117 mdpl Kategori khusus atlet Kejurda dengan rute menanjak dari Balai Besar TNGGP Cibodas menuju Camp Area Kandang Badak. Elevasi total 1.117 m, dengan kemiringan rata-rata 10%. Jalur berbatu tertata rapi, didominasi tanjakan terjal dan dikelilingi hutan tropis serta udara pegunungan yang sejuk. Tantangan maksimal untuk pelari vertikal.",
        distance: 7,
        elevationGain: 1117,
        eventDateTimestamp: "27 Sept 2025 at 06:30:00 UTC+7",
        gpxFileUrl: "",
        imageUrl:
          "https://firebasestorage.googleapis.com/v0/b/cakrawala-jakartakreatif.firebasestorage.app/o/elevation_images%2FCHANDRA-ALTI2023SULTENG-7032.jpg_1754800088800?alt=media&token=61665ab3-d5f0-4db0-ba22-98174bfe4598",
        mapUrl: "",
        price: 700000,
        rundown: [{ time: "06:30" }],
      },
      {
        categoryName: "Classic Distance (20K)",
        cot: 12,
        date: "2025-09-27",
        description:
          "Classic Distance - 20 KM | Elevation Gain ±1.586 m Rute dimulai dari Balai TNGGP Cibodas menuju Kandang Badak, dilanjutkan ke puncak Gunung Gede (2.958 m), lalu menurun melalui Alun-alun Surya Kencana, jalur Basecamp Putri, dan kembali ke Race Village. Medan bervariasi: tanjakan terjal, punggungan datar, hingga turunan teknikal panjang. Cocok untuk pelari berpengalaman yang siap menghadapi tantangan fisik sekaligus menikmati panorama kawah aktif, hamparan edelweis, dan hutan pegunungan.",
        distance: 20,
        elevationGain: 1673,
        eventDateTimestamp: "27 Sept 2025 at 03:00:00 UTC+7",
        gpxFileUrl: "",
        imageUrl:
          "https://firebasestorage.googleapis.com/v0/b/cakrawala-jakartakreatif.firebasestorage.app/o/elevation_images%2FCHANDRA-ALTI2023SULTENG-6489.jpg_1754801894471?alt=media&token=d3f49b3b-5555-413d-b1b2-885098d026e8",
        mapUrl: "",
        price: 759900,
        rundown: [{ time: "03:00" }],
      },
      {
        categoryName: "Short Distance (40K)",
        cot: 20,
        date: "2025-09-27",
        description:
          "Short Distance - 40 KM | Elevation Gain ±3.345 m Rute dimulai dari Balai Besar TNGGP Cibodas, menuju Kandang Badak dan puncak Gunung Gede, lalu menurun lewat Surya Kencana, Basecamp Putri, dan melewati Kebun Raya Cibodas sebelum kembali ke garis akhir. Medan menantang dengan jalur single track, tanjakan curam, turunan teknikal, dan trek berbatu. Cocok untuk pelari tangguh yang siap uji fisik dan mental di lintasan ekstrem.",
        distance: 40,
        elevationGain: 3345,
        eventDateTimestamp: "27 Sept 2025 at 05:30:00 UTC+7",
        gpxFileUrl: "",
        imageUrl:
          "https://firebasestorage.googleapis.com/v0/b/cakrawala-jakartakreatif.firebasestorage.app/o/elevation_images%2FCHANDRA-ALTI2023SULTENG-6889.jpg_1754800947104?alt=media&token=558a9a20-7578-4f5e-93f1-1011fefb1419",
        mapUrl: "",
        price: 1067000,
        rundown: [{ time: "05:30" }],
      },
      {
        categoryName: "Long Distance (80 K)",
        cot: 35,
        date: "2025-09-27",
        description:
          "Long Distance - 80 KM | Elevation Gain ±6.685 m Rute ini merupakan 4 loop dari jalur Classic, dimulai dari Balai Besar TNGGP Cibodas, mendaki ke Kandang Badak, puncak Gunung Gede (2.958 mdpl), lalu menurun lewat Surya Kencana, Basecamp Putri, dan kembali ke Race Village. Medan ekstrem dengan tanjakan curam, turunan teknikal, dan jalur single track. Kategori ini dirancang untuk pelari ultra berpengalaman, dengan tantangan cuaca, fisik, dan mental sepanjang lintasan. Panorama kawah aktif, hutan tropis, dan bentang alam TNGGP menjadi bagian dari perjalanan epik penuh ketangguhan.",
        distance: 80,
        elevationGain: 6487,
        eventDateTimestamp: "27 Sept 2025 at 01:00:00 UTC+7",
        gpxFileUrl: "",
        imageUrl:
          "https://firebasestorage.googleapis.com/v0/b/cakrawala-jakartakreatif.firebasestorage.app/o/elevation_images%2FCHANDRA-ALTI2023SULTENG-7153.jpg_1754800194896?alt=media&token=b7b3a827-ea47-4288-aff1-f3e7950fb6d8",
        mapUrl: "",
        price: 1622000,
        rundown: [{ time: "01:00" }],
      },
      {
        categoryName: "Fun Trail (7K)",
        cot: 4,
        date: "2025-09-27",
        description:
          "Fun Trail (7Km) | Nikmati petualangan menyusuri jalur hutan yang sejuk, udara pegunungan yang segar, dan pemandangan alam yang memukau. Dalam perjalanan, Anda akan melewati Danau Biru yang berada di jalur menuju Jembatan Rawa Gayonggon jembatan ikonik yang membentang di atas hamparan rawa alami. Rute ini akan membawa Anda menuju Curug Cibeureum yang ikonik, di mana gemericik air terjun dan rimbunnya alam taman nasional Gede pangrango.",
        distance: 7,
        elevationGain: 370,
        eventDateTimestamp: "27 Sept 2025 at 07:00:00 UTC+7",
        gpxFileUrl: "",
        imageUrl: null,
        mapUrl: "",
        price: 595000,
        rundown: [{ time: "07:00" }],
      },
    ],
  },

  {
    id: "BMM",
    eventId: "BMM",
    slug: "BMM",
    title: "BALI MOUNTAIN MARATHON",
    logo: "/logo/smm.png",
    logodetail: "/logo/smm1.png",
    type: "trail_running",
    status: "Registrasi Dibuka",
    location: "Bali",
    image: "/bg/bghero2.png",
    currentImage: "/bg/bghero2.png",
    price: 0,
    websiteUrl: "https://bmm2025.cakrawalajakarta.id",
    aboutEvent:
      "Bali Mountain Marathon adalah event trail running premium di Pulau Dewata. Event ini menggabungkan tantangan trail running dengan keindahan alam dan budaya Bali yang khas.",
    createdAt: "30 Jul 2025 at 18:09:08 UTC+7",
    updatedAt: "4 Nov 2025 at 21:44:46 UTC+7",
    detailPath: "/BMM", // LINK STATIS
    categories: [
      {
        categoryName: "Vertical (7K)",
        cot: 2,
        date: "2026-01-10",
        description:
          "Vertical Challenge (7 Km) | Elevation Gain 1.117 mdpl Kategori khusus dengan rute menanjak di kawasan pegunungan Bali.",
        distance: 7,
        elevationGain: 1117,
        eventDateTimestamp: "10 Jan 2026 at 06:30:00 UTC+7",
        gpxFileUrl: "",
        imageUrl: "",
        mapUrl: "",
        price: 700000,
        rundown: [{ time: "06:30" }],
      },
    ],
  },
];
